<!-- <p-dialog [header]="'SHARED.TERMS-OF-USE' | translate" [style]="{ maxWidth: '640px' }" [modal]="true" [draggable]="false" [blockScroll]="true" [(visible)]="tpcService.showTermsOfUse">
    <div class="text-justify">
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
    </div>
</p-dialog>

<p-dialog [header]="'SHARED.PRIVACY-POLICY' | translate" [style]="{ maxWidth: '640px' }" [modal]="true" [draggable]="false" [blockScroll]="true" [(visible)]="tpcService.showPrivacyPolicy" >
    <div class="text-justify">
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
    </div>
</p-dialog> -->

<div *ngIf="tpcService.showCookiesConsent" class="cookie-policy-banner">
    <div>
        <span>{{ 'COOKIES.T1' | translate }}</span>
        <br />
        <span>{{ 'COOKIES.T2' | translate }}
            <span class="url-like" (click)="tpcService.showTermsOfUse = true">{{ 'SHARED.PRIVACY_POLICY' | translate | lowercase }}</span>.
        </span>
    </div>
    <div class="float-right">
        <!-- <button class="ml-2 navbar-button button-default" [routerLink]="'./new'">
            <i class="dx-icon-plus"></i>
            <span class="btn-text">{{ 'SHARED.CREATE' | translate }}</span>
        </button> -->
        <button class="ml-2 navbar-button button-secondary" (click)="accept()">
            <span class="text-uppercase">{{ 'SHARED.ACCEPT' | translate }}</span>
        </button>
    </div>
</div>
